// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/audit-events/:id\",\"regex\":\"^/admin/audit-events/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/docs/:id\",\"regex\":\"^/admin/docs/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/orgs/:id\",\"regex\":\"^/admin/global/orgs/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/tenants/:id\",\"regex\":\"^/admin/global/tenants/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/users/:id\",\"regex\":\"^/admin/global/users/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/workflow-builder/:sessionId\",\"regex\":\"^/admin/global/workflow-builder/([^/]+)$\",\"paramNames\":[\"sessionId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/workflows/:workflowId\",\"regex\":\"^/admin/global/workflows/([^/]+)$\",\"paramNames\":[\"workflowId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/global/workflows/instances/:instanceId\",\"regex\":\"^/admin/global/workflows/instances/([^/]+)$\",\"paramNames\":[\"instanceId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/locations/:id\",\"regex\":\"^/admin/locations/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/locations/:id/regions\",\"regex\":\"^/admin/locations/([^/]+)/regions$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/modules/:moduleId\",\"regex\":\"^/admin/modules/([^/]+)$\",\"paramNames\":[\"moduleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/modules/:moduleId/workflows\",\"regex\":\"^/admin/modules/([^/]+)/workflows$\",\"paramNames\":[\"moduleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/orgs/:id\",\"regex\":\"^/admin/orgs/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/orgs/:id/:moduleId\",\"regex\":\"^/admin/orgs/([^/]+)/([^/]+)$\",\"paramNames\":[\"id\",\"moduleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/orgs/:id/:moduleId/workflows\",\"regex\":\"^/admin/orgs/([^/]+)/([^/]+)/workflows$\",\"paramNames\":[\"id\",\"moduleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/orgs/:id/users\",\"regex\":\"^/admin/orgs/([^/]+)/users$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/orgs/:id/users/assign\",\"regex\":\"^/admin/orgs/([^/]+)/users/assign$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/release-notes/:id\",\"regex\":\"^/admin/release-notes/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/release-notes/:id/view\",\"regex\":\"^/admin/release-notes/([^/]+)/view$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/roles/:id\",\"regex\":\"^/admin/roles/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/roles/:id/users\",\"regex\":\"^/admin/roles/([^/]+)/users$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/users/:id\",\"regex\":\"^/admin/users/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/workflowType/:id\",\"regex\":\"^/admin/workflowType/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/dashboards/:id\",\"regex\":\"^/dashboards/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/error/:id\",\"regex\":\"^/error/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/modules/:id\",\"regex\":\"^/modules/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/modules/:id/items/:itemId\",\"regex\":\"^/modules/([^/]+)/items/([^/]+)$\",\"paramNames\":[\"id\",\"itemId\"],\"hasOptionalPrefix\":false},{\"path\":\"/modules/:id/items/:itemId/print\",\"regex\":\"^/modules/([^/]+)/items/([^/]+)/print$\",\"paramNames\":[\"id\",\"itemId\"],\"hasOptionalPrefix\":false},{\"path\":\"/monitoring/:id\",\"regex\":\"^/monitoring/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/admin\"},{\"path\":\"/admin/audit-events\"},{\"path\":\"/admin/dashboard\"},{\"path\":\"/admin/docs\"},{\"path\":\"/admin/global\"},{\"path\":\"/admin/global/diagnostics\"},{\"path\":\"/admin/global/diagnostics/workflows\"},{\"path\":\"/admin/global/import\"},{\"path\":\"/admin/global/import/user-roles\"},{\"path\":\"/admin/global/orgs\"},{\"path\":\"/admin/global/tenants\"},{\"path\":\"/admin/global/unassigned\"},{\"path\":\"/admin/global/users\"},{\"path\":\"/admin/global/workflow-builder\"},{\"path\":\"/admin/global/workflows\"},{\"path\":\"/admin/locations\"},{\"path\":\"/admin/locations/create\"},{\"path\":\"/admin/module-files\"},{\"path\":\"/admin/modules\"},{\"path\":\"/admin/orgs\"},{\"path\":\"/admin/orgs/create\"},{\"path\":\"/admin/release-notes\"},{\"path\":\"/admin/release-notes/create\"},{\"path\":\"/admin/roles\"},{\"path\":\"/admin/roles/create\"},{\"path\":\"/admin/users\"},{\"path\":\"/admin/users/create\"},{\"path\":\"/admin/workflowType\"},{\"path\":\"/auth/error/account\"},{\"path\":\"/auth/error/denied\"},{\"path\":\"/auth/error/signin\"},{\"path\":\"/auth/signIn\"},{\"path\":\"/auth/signOut\"},{\"path\":\"/ai-docs\"},{\"path\":\"/dashboards\"},{\"path\":\"/error\"},{\"path\":\"/healthz\"},{\"path\":\"/modules\"},{\"path\":\"/monitoring\"},{\"path\":\"/release-notes\"},{\"path\":\"/user\"},{\"path\":\"/api-docs\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.0";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

import {
  getLogger,
  LogCategory,
  LogEvent,
  LogEventCategory,
  LogLevel,
} from '@cntxt/shared/infrastructure';
import {
  cacheService,
  SENTRY_SESSION_CACHE_KEY,
  SENTRY_SESSION_CACHE_TTL,
} from '@cntxt/shared/infrastructure/cache';
import { getSession } from '@cntxt/shared/infrastructure/session';
import { env } from '@cntxt/shared/utilities/envs';
import { sentryThemeConfig } from '@cntxt/shared/utilities/theme';

const logger = getLogger('SentryClientInit');

/**
 * Skip Sentry initialization if
 * - local/development environment
 * - if DSN is not provided
 * - not running in a browser (instrumentation-client is client-only)
 */
const isDevelopment = process.env.NODE_ENV === 'development';
const enableSessionReplay =
  env.NEXT_PUBLIC_ENABLE_SENTRY_SESSION_REPLAY === 'true';
const hasDsn = !!env.NEXT_PUBLIC_SENTRY_DSN;
const windowAvailable = typeof window !== 'undefined';
const replaysEnabled = windowAvailable && enableSessionReplay;

// Helper function to escape regex special characters
const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const protectedPathsRegex = /\/(admin|user)/;

const replaySettings = {
  // Set max duration to 10 minutes (milliseconds)
  maxReplayDuration: 600000,
  mutationLimit: 5000,
  // Disable sticky sessions to prevent memory accumulation
  // Sticky sessions keep replay data in memory indefinitely
  stickySession: false,
  // Masking settings
  maskAllText: replaysEnabled
    ? protectedPathsRegex.test(window.location.pathname)
    : false,
  maskAllInputs: true,
  blockAllMedia: true,
  mask: [
    '.sentry-mask',
    '[data-sentry-mask]',
    '.location-selector-button',
    'select',
    'option',
    '[role="listbox"]',
    '[role="option"]',
    '.dropdown',
    '.select',
    '.menu',
    'ul',
    'ol',
    'li',
    '[role="list"]',
    '[role="listitem"]',
    'table',
    '.placepicker_gmap',
    '[class*="Location"]',
    '[class*="location"]',
    '[class*="Map"]',
    '[class*="map"]',
    '[class*="Marker"]',
    '[class*="marker"]',
    '.google-map',
    '.gmap',
    '[data-map]',
    '[data-location]',
  ],
  networkDetailAllowUrls: replaysEnabled
    ? [
        new RegExp(
          `^${escapeRegex(window.location.origin)}/(?!.*(?:login|logout|auth|sign-in|sign-out|signin|signout|user|/iam))`,
          'i',
        ),
        /^\/api\/(?!.*(?:login|logout|auth|sign-in|sign-out|signin|signout|user|\/iam))/i,
      ]
    : [],
};

const feedbackSettings = {
  autoInject: true,
  showBranding: false,
  showName: false,
  showEmail: false,
  colorScheme: 'light',
  themeLight: sentryThemeConfig.light,
  themeDark: sentryThemeConfig.dark,
  triggerLabel: '',
  formTitle: 'Report problem | Give feedback',
  messagePlaceholder:
    'Help us improve by sharing your feedback or reporting issues.',
  addScreenshotButtonLabel: 'Screenshot',
  submitButtonLabel: 'Send report',
  useSentryUser: {
    name: 'name',
  },
};

/** Keep Sentry user context in sync after auth changes during client navigations. */
function syncSentryUserFromSession() {
  if (isDevelopment || !hasDsn || !windowAvailable) {
    return;
  }

  const cachedSession = cacheService.get<{ user: { id: string } | null }>(
    SENTRY_SESSION_CACHE_KEY,
  );

  if (cachedSession) {
    if (cachedSession.user) {
      Sentry.setUser({ id: cachedSession.user.id });
    } else {
      Sentry.setUser(null);
    }
    return;
  }

  getSession()
    .then((session) => {
      if (session?.user) {
        Sentry.setUser({ id: session.user.id });
        cacheService.set(
          SENTRY_SESSION_CACHE_KEY,
          { user: { id: session.user.id } },
          SENTRY_SESSION_CACHE_TTL,
        );
      }
    })
    .catch(() => {
      // Fail silently if session fetch fails
    });
}

if (!isDevelopment && hasDsn && windowAvailable) {
  // Use NEXT_PUBLIC_* variables which are accessible on the client
  const enableLogs = env.NEXT_PUBLIC_SENTRY_LOGS === 'true';
  const tracesSampleRate = env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? 0.1; // Default to 10% in production
  const replaysSessionSampleRate =
    env.NEXT_PUBLIC_SENTRY_REPLAY_SAMPLE_RATE ?? 0.1; // Default to 10% in production

  try {
    Sentry.init({
      dsn: env.NEXT_PUBLIC_SENTRY_DSN,
      environment: env.NEXT_PUBLIC_APP_ENV || 'development',
      release: env.NEXT_PUBLIC_APP_VERSION,
      sendDefaultPii: true,

      // Configurable sample rate - defaults to 10% to avoid overhead in production
      tracesSampleRate,

      // Propagate traces to same-origin API routes and the AI copilot service
      tracePropagationTargets: [
        'localhost',
        /^\//,
        new RegExp(`^${escapeRegex(window.location.origin)}`),
        ...(env.NEXT_PUBLIC_AI_API_BASE_URL
          ? [env.NEXT_PUBLIC_AI_API_BASE_URL]
          : []),
      ],

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: enableLogs,

      replaysOnErrorSampleRate: 1,

      // 1.0 (100%) is not recommended: profiling every sampled transaction
      // exhausted memory and crashed work-permit pods. Default 0.1 (10%).
      profileSessionSampleRate:
        env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,
      profileLifecycle: 'trace',

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      integrations: (defaultIntegrations: any) => [
        ...defaultIntegrations,
        ...(enableSessionReplay
          ? [Sentry.replayIntegration(replaySettings)]
          : []),
        Sentry.feedbackIntegration(feedbackSettings),
        Sentry.browserProfilingIntegration(),
      ],
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate,
    });

    // Set user data from session after initialization
    getSession()
      .then((session) => {
        if (session?.user) {
          Sentry.setUser({
            id: session.user.id,
            email: session.user.email ?? undefined,
            username: session.user.name ?? undefined,
          });
        }
      })
      .catch(() => {
        // Fail silently if session fetch fails
      });
  } catch (err) {
    logger.contextualLog(
      LogLevel.ERROR,
      'Sentry client package error',
      undefined,
      {
        err,
        event: LogEvent.INSTRUMENTATION,
        eventCategory: LogEventCategory.INSTRUMENTATION,
        category: LogCategory.INSTRUMENTATION,
      },
    );
  }
}

/**
 * Instrument App Router navigations for tracing (and trace-mode profiling).
 * Must delegate to Sentry first; Next 15.3+ requires this hook for navigation spans.
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/
 */
export function onRouterTransitionStart(
  ...args: Parameters<typeof Sentry.captureRouterTransitionStart>
): void {
  Sentry.captureRouterTransitionStart(...args);
  syncSentryUserFromSession();
}
